import { useMemo } from 'react';
const webpSrcRegex = /\.webp(?=\?|$)/;
const webpSrcSetRegex = /\.webp(?=\?|\s|,|$)/g;
const yamsWebpSrcRegex = /(?!\?rule=.*)(-webp)/;
const yamsWebpSrcSetRegex = /(?!\?rule=.*)(-webp)/g;
const yamsImageRegex = /[?&]rule=/;
const getWebpSrcRegex = (src, webpFallbackFormat) => {
    if (yamsImageRegex.test(src)) {
        return {
            srcRegex: yamsWebpSrcRegex,
            srcSetRegex: yamsWebpSrcSetRegex,
            fallbackExtension: `-${webpFallbackFormat}`
        };
    }
    return {
        srcRegex: webpSrcRegex,
        srcSetRegex: webpSrcSetRegex,
        fallbackExtension: `.${webpFallbackFormat}`
    };
};
const useWebp = ({ src, srcSet, webpFallbackFormat }) => {
    const { srcRegex, srcSetRegex, fallbackExtension } = useMemo(() => getWebpSrcRegex(src, webpFallbackFormat), [src, webpFallbackFormat]);
    const isWebp = useMemo(() => srcSet
        ? srcRegex.test(src) && srcSetRegex.test(srcSet)
        : srcRegex.test(src), [src, srcSet, srcRegex, srcSetRegex]);
    const { srcFallback, srcSetFallback } = useMemo(() => isWebp
        ? {
            srcFallback: src.replace(srcRegex, fallbackExtension),
            srcSetFallback: srcSet
                ? srcSet.replace(srcSetRegex, fallbackExtension)
                : undefined
        }
        : { srcFallback: undefined, srcSetFallback: undefined }, [src, srcSet, fallbackExtension, isWebp, srcRegex, srcSetRegex]);
    return {
        isWebp,
        srcFallback,
        srcSetFallback
    };
};
export default useWebp;
//# sourceMappingURL=useWebp.js.map